import React from "react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../common/hooks/hooks";
import { setInStock } from "../../../productSlice";
import { RootState } from "../../../../../../app/store";

const InStockFilter: React.FC<{ idPrefix: string }> = ({ idPrefix }) => {
  const dispatch = useAppDispatch();
  const { t, ready: areTranslationsReady } = useTranslation();

  const isInStock = useAppSelector(
    (state: RootState) => state.product.filters.inStock
  );

  const handleToggle = () => {
    // Dispatch the opposite of the current state
    dispatch(setInStock(!isInStock));
  };

  const isComponentLoading = !areTranslationsReady;
  const toggleId = `${idPrefix}in-stock-toggle`;

  return (
    <div className="filter-widget in-stock-filter">
      {isComponentLoading ? (
        <div style={{ padding: "0.5rem 0" }}>
          <Skeleton width="80%" height={24} />
        </div>
      ) : (
        <label
          htmlFor={toggleId}
          className={`filter-widget__label ${isInStock ? "is-active" : ""}`}
          style={{ padding: 0 }}
        >
          <input
            type="checkbox"
            id={toggleId}
            className="filter-widget__checkbox"
            checked={isInStock}
            onChange={handleToggle}
          />
          <span className="filter-widget__name">
            {t(
              "productsArchive.sidebar.inStockLabel",
              "Sadece stoktaki ürünler"
            )}
          </span>
        </label>
      )}
    </div>
  );
};

export default InStockFilter;
